/**
 * 老板的工作桌面
 * created by lei lei on 2020/5/29
 */
import React, {Component} from 'react';

import ActivityTrendsComponents from "./components/activityTrends/ActivityTrendsComponents";
import TopicSubmissionReminderComponents from "./components/activityTrends/TopicSubmissionReminderComponents";
import ActivityCompletionComponents from "./components/activityCompletion/ActivityCompletionComponents";
import ResourceStaticComponents from "./components/resourceStatic/ResourceStaticComponents";
import PublishRankingsComponents from "./components/publishRank/PublishRankingsComponents";
import ActivityPendingComponentsOther from "./components/activityPending/ActivityPendingComponentsOther";
import ActivityRankingComponents from "./components/activityRanking/ActivityRankingComponents"
import Shortcuts from './components/shortcuts/Shortcuts'
import FollowUpCorrespondenceComponents from "./components/activityTrends/FollowUpCorrespondenceComponents";
import MyMessage from "./components/myMessage/MyMessage"
import './StatciMyDesktop.css'
import ActivityPendingComponents from "./components/activityPending/ActivityPendingComponents";
import MyTopicList from"./components/myTopicList/myTopicList"
import {Scrollbars} from 'react-custom-scrollbars';
import TaskList from'./components/taskList/TaskList'
import OrderDay from'./components/orderDay/OrderDay'
import WorkRecord from './components/workRecord/WorkRecord'
export default class StaticMyDesk extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let height = window.innerHeight - 70;
        return (
            <div style={{height: height}}>
                <Scrollbars>
                    <div style={{position: 'relative', height: height, maxWidth: 1440,margin:"auto"}}>

                        <div className={'myDeskPadding'} style={{position: 'relative', marginBottom: 20}}>

                            <Shortcuts {...this.props}/>
                            <TaskList/>
                            <div style={{display: 'flex',}}>
                                <div className={'myDeskLeft'} style={{width: '55%'}}>
                                    <ActivityPendingComponents/>
                                    <FollowUpCorrespondenceComponents/>
                                    <ActivityCompletionComponents/>
                                    {/* <ActivityRankingComponents/>*/}
                                    {/* <TopicSubmissionReminderComponents/>*/}
                                    <MyTopicList/>
                                    <WorkRecord/>
                                </div>
                                <div className={'myDeskRight'} style={{width: '45%',}}>
                                    <MyMessage/>
                                    {/*  <ActivityPendingComponentsOther/>*/}
                                    <ActivityTrendsComponents/>
                                    <PublishRankingsComponents/>
                                    <ResourceStaticComponents/>
                                    <OrderDay/>
                                </div>
                            </div>

                        </div>

                    </div>
                </Scrollbars>
            </div>
        )
    }
}

